module.exports = __webpack_public_path__ + "img/Banner1.57d098c0.jpg";